import type { RequiredGeneric } from '@pba/utils';
import { useTranslation } from 'react-i18next';
import { Col, Form, Input, Row, Select } from 'ui';
import { countries, states } from 'common/utils';

export type AddressValues = {
  apartment?: string;
  city: string;
  country: string;
  state?: string;
  street: string;
  zip: string;
};

const AddressFormContent = <T extends AddressValues = never>(_: RequiredGeneric<T>) => {
  const { t: translationCountry } = useTranslation('translationCountries');
  const { t: translationState } = useTranslation('translationStates');

  return (
    <>
      <Row gutter="xs">
        <Col span={12}>
          <Form.Item<AddressValues> label="Street" name="street" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item<AddressValues> label="Apartment" name="apartment">
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item<AddressValues> label="City" name="city" rules={[{ required: true }]}>
        <Input />
      </Form.Item>
      <Form.Item<AddressValues> dependencies={['country']} noStyle>
        {({ getFieldValue }) =>
          getFieldValue('country') === 'US' ? (
            <Form.Item<AddressValues> label="State" name="state" rules={[{ required: true }]}>
              <Select
                options={states.map((option) => ({
                  label: translationState(option.translationKey),
                  value: option.code,
                }))}
                showSearch={{ optionFilterProp: 'label' }}
              />
            </Form.Item>
          ) : null
        }
      </Form.Item>
      <Form.Item<AddressValues> label="ZIP code" name="zip" rules={[{ required: true }]}>
        <Input />
      </Form.Item>
      <Form.Item<AddressValues> label="Country" name="country" rules={[{ required: true }]}>
        <Select
          options={countries.map((option) => ({
            label: translationCountry(option.translationKey),
            value: option.code,
          }))}
          showSearch={{ optionFilterProp: 'label' }}
        />
      </Form.Item>
    </>
  );
};

export default AddressFormContent;
